import type { IconProps } from './types';
import './icons.css';

export default function Duplicate({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 16}
      height={height || 16}
      viewBox="0 0 16 16"
      className={`icon icon-duplicate ${className || ''}`}
    >
      <g clipPath="url(#duplicate-a)">
        <g
          clipPath="url(#duplicate-b)"
          stroke="currentColor"
          strokeLinecap="round"
          fill="transparent"
          strokeLinejoin="round"
        >
          <path
            d="M13.333 6h-6C6.597 6 6 6.597 6 7.333v6c0 .737.597 1.334 1.333 1.334h6c.737 0 1.334-.597
            1.334-1.334v-6c0-.736-.597-1.333-1.334-1.333Z"
          />
          <path d="M3.333 10h-.666a1.333 1.333 0 0 1-1.334-1.333v-6c0-.737.597-1.334 1.334-1.334h6c.736 0 1.333.597 1.333 1.334v.666" />
        </g>
      </g>
      <defs>
        <clipPath id="duplicate-a">
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
        <clipPath id="duplicate-b">
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
